import CustomFontStyle from "./CustomFontStyle";

export default CustomFontStyle;



// WEBPACK FOOTER //
// ./src/components/RevvToolBar/CustomFontStyle/index.js